import { actions as attractionsActions } from "./reducers/attractions/attractionsSlice";
import { actions as contactMethodsActions } from "./reducers/contactMethods/contactMethodsSlice";
import { actions as generalActions } from "./reducers/general/generalSlice";
import { actions as favoritesActions } from "./reducers/favorites/favoritesSlice";

const rootActions = {
  attractions: attractionsActions,
  contactMethods: contactMethodsActions,
  general: generalActions,
  favorites: favoritesActions,
};

export default rootActions;
